import React from "react";
import "./brim.scss";
import MuiRadio from "../radio/MuiRadio";
import kneeDisartic from "../../images/kneeDisartic.png";
import tcNarrowMedLat from "../../images/tcNarrowMedLat.png";
import TCNarrowMedLat_3 from "../../images/3-TCNarrowMedLat.png";
import TCNarrowMedLat_4 from "../../images/4-TCNarrowMedLat.png";
import TCNarrowMedLat_6 from "../../images/6-TCNarrowMedLat.png";
import TCNarrowMedLat_7 from "../../images/7-TCNarrowMedLat.png";
import TCNarrowMedLat_8 from "../../images/8-TCNarrowMedLat.png";
import TCNarrowMedLat_9 from "../../images/9-TCNarrowMedLat.png";
import TCNarrowMedLat_13 from "../../images/9-TCNarrowMedLat.png";
import TCQuad_10 from "../../images/10-TCQuad.png";
import TCQuad_11 from "../../images/11-TCQuad.png";
import TCQuad_12 from "../../images/12-TCQuad.png";

const Brim = ({ onChange, options, defaultValue, error, required }) => {
  const imageMapping = [
    {
      name: "#1 - Knee Disartic",
      img: kneeDisartic,
    },
    {
      name: "#2 - TCNarrowMedLat 1",
      img: tcNarrowMedLat,
    },
    {
      name: "#3 - TCNarrowMedLat 2",
      img: TCNarrowMedLat_3,
    },
    {
      name: "#4 - TCNarrowMedLat 3",
      img: TCNarrowMedLat_4,
    },
    {
      name: "#5 - TCNarrowMedLat 4",
      img: TCNarrowMedLat_6,
    },
    {
      name: "#6 - TCNarrowMedLat 5",
      img: TCNarrowMedLat_7,
    },
    {
      name: "#7 - TCNarrowMedLat 6",
      img: TCNarrowMedLat_8,
    },
    {
      name: "#8 - TCNarrowMedLat 7",
      img: TCNarrowMedLat_9,
    },
    {
      name: "#9 - TCNarrowMedLat 8",
      img: TCNarrowMedLat_13,
    },
    {
      name: "#10 - TCQuad 1",
      img: TCQuad_10,
    },
    {
      name: "#11 - TCQuad 2",
      img: TCQuad_11,
    },
    {
      name: "#12 - TCQuad 3",
      img: TCQuad_12,
    },
    {
      name: "#13 - TCQuad 4",
      img: TCQuad_12,
    },
  ];

  const newOption = options.map((option) => ({
    displayName: option.displayName,
    id: option.id,
    img: imageMapping.find((img) => img.name === option.displayName)?.img,
  }));

  return (
    <div className="brimRadio">
      <MuiRadio
        options={newOption.filter((item) => item.displayName !== "My Brim")}
        required={required}
        error={error}
        label="Brim"
        onChange={onChange}
        defaultValue={defaultValue}
      />
    </div>
  );
};

export default Brim;
